module.exports = __webpack_public_path__ + "static/img/108.9ea4861a.gif";